export default __webpack_public_path__ + "images/499a600ccd01152629295e4007dd20e7-family.png";